import { Sentry, sentryEnabled } from '@/lib/sentry';

type ChatUxMilestone = 'firstActivity' | 'firstText' | 'thinking' | 'userMessage';

type ActiveChatUxTurn = {
  marked: Set<ChatUxMilestone>;
  sampled: boolean;
  startedAt: number;
};

const SAMPLE_RATE = 0.1;
let activeTurn: ActiveChatUxTurn | null = null;

function now() {
  return typeof performance === 'undefined' ? Date.now() : performance.now();
}

function recordDistribution(name: string, value: number) {
  if (!activeTurn?.sampled || !sentryEnabled) {
    return;
  }

  Sentry.metrics.distribution(name, Math.max(0, value), {
    unit: 'millisecond',
  });
}

function markMilestone(milestone: ChatUxMilestone, metricName: string) {
  if (!activeTurn || activeTurn.marked.has(milestone)) {
    return;
  }

  activeTurn.marked.add(milestone);
  recordDistribution(metricName, now() - activeTurn.startedAt);
}

export function startChatUxTurn() {
  activeTurn = {
    marked: new Set(),
    sampled: Math.random() < SAMPLE_RATE,
    startedAt: now(),
  };
}

export function markChatUserMessageVisible() {
  markMilestone('userMessage', 'chat.ui.submit_to_user_message_ms');
}

export function markChatThinkingVisible() {
  markMilestone('thinking', 'chat.ui.submit_to_thinking_visible_ms');
}

export function markChatAssistantActivityVisible() {
  markMilestone('firstActivity', 'chat.ui.submit_to_first_visible_assistant_activity_ms');
}

export function markChatFirstTextVisible() {
  markMilestone('firstText', 'chat.ui.submit_to_first_text_ms');
}

export function countChatUxEvent(name:
  | 'chat.ui.ask_user_retry'
  | 'chat.ui.blank_assistant_state_count'
  | 'chat.ui.retry_after_stream_error'
  | 'chat.ui.stream_error_inline_shown'
  | 'chat.ui.user_abort'
) {
  if (!activeTurn?.sampled || !sentryEnabled) {
    return;
  }

  Sentry.metrics.count(name, 1);
}
